import type { MutableRefObject, ReactNode } from "react";

export enum ImageShapeEnum {
  Free = "free",
  Square = "square",
  Circle = "circle",
  Rectangle = "16-9",
  Blob = "blob",
  Parallelogram = "parallelogram",
  FreeForm = "axis-resize",
}

export type ImageProps = {
  src: string;
  updatedSrc: string | null;
  /**
   * The picture an AI fill replaced, kept so the three-dots menu can offer
   * "Restore original image" while `src` differs from it.
   */
  originalImageSrc?: string | null;
  alt: string;
  shape: string;
  round: string;
  width: string;
  height: number;
  verticalAlignment: string;
  horizontalAlignment: string;
  isLinkActive: boolean;
  linkUrl: string;
  linkAnalyticEvent: string;
  cropData: any;
  isAnchorActive: boolean;
  anchorName: string;
  anchorTrigger: string;
  selectedLinkType: string | null;
  name: string;
  AIClassificationAnchor: string;
  openInPopup?: boolean;
  dynamicVariableSrc?: string;
  ariaLabel?: string;
  overlay?: boolean;
  overlayOpacity?: number;
  overlayColor?: string;
  animation?: boolean;
  animationStyle?: "zoom" | "slide";
  animationDirection?: "left" | "right";
  animationType?: "zoomIn" | "zoomOut";
  metadata?: {
    width: number;
    height: number;
    scale?: number;
    translateX?: number;
    translateY?: number;
  };
  blackAndWhite?: boolean;
  shadow: string;
  shadowOpacity?: number | "design-system";
  shadowColor?: string | "design-system";
  blobType?: string;
  parallelogramDirection?: string;
  customDynamicVariable?: string;
};

export interface ImageRef {
  element: HTMLDivElement | null;
  imageContainer: HTMLDivElement | null;
}

export type EditorDataProps = {
  width: string;
  height: number;
  isAdmin: boolean;
  elementRef: MutableRefObject<HTMLDivElement | null>;
  imageContainerRef: MutableRefObject<HTMLDivElement | null>;
  handleMediaDialog: () => void;
};

export type EditorSlotsProps = {
  resizeSlot: ReactNode;
  dynamicVariableDotSlot: ReactNode;
  dynamicVariablePlateSlot: ReactNode;
};

export type ImageWrapperProps = {
  $verticalAlignment: string;
  $horizontalAlignment: string;
  $hasDynamicVariable: boolean;
};

export type ImageLayoutProps = {
  $round: string;
  $shape: string;
  $isLogo?: boolean;
  $shadow: string;
  $shadowOpacity?: number | "design-system";
  $shadowColor?: string | "design-system";
  $metadata?: {
    width: number;
    height: number;
    blurhash?: string;
  };
  $overlayOpacity?: number | "design-system" | undefined;
  $overlayColor?: string | undefined;
  $blackAndWhite?: boolean | "design-system";
  $blobType?: string | undefined;
  $parallelogramDirection?: string | undefined;
};

export type ImageElementProps = {
  $round: string;
  $filter?: boolean | "design-system" | undefined;
  $blobType?: string | undefined;
  $shape?: string;
  $parallelogramDirection?: string | undefined;
};
